import React, { useEffect, useState } from 'react';
import { View, Text, Image, TouchableOpacity, StyleSheet, ScrollView } from 'react-native-web';
import { Link, Outlet, useLocation } from "react-router-dom";
import dupeLogo from "../icons/Dupe_Logo_White.png";
import yellowNetworkIcon from "../icons/yellow-network-icon.png";
import yellowMagnifyingIcon from "../icons/yellow-magnifying-icon.png";
import yellowLandscapeIcon from "../icons/yellow-landscape-icon.png";
import yellowAnnouncementIcon from "../icons/yellow-announcement-icon.png";
import yellowMessagesIcon from "../icons/yellow-send-icon.png";
import yellowGridIcon from "../icons/yellow-grid-icon.png";
import gearIcon from "../icons/gear.png";
import doorIcon from "../icons/door.png";
import {signOut} from "aws-amplify/auth";

const SideBar = ({ paymentRequired }) => {
    const location = useLocation();
    const [currentPath, setCurrentPath] = useState("");

    useEffect(() => {
        setCurrentPath(location.pathname);
    }, [location]);

    const renderMenuItem = (to, icon, text) => (
        <Link to={to} style={styles.link}>
            <View style={[styles.menuItem, currentPath === to && styles.selectedMenuItem]}>
                <Image source={icon} style={styles.icon} />
                <Text style={styles.menuText}>{text}</Text>
            </View>
        </Link>
    );

    return (
        <View style={styles.container}>
            <View style={styles.sidebar}>
                <View style={styles.logoContainer}>
                    <Image source={dupeLogo} style={styles.logo} />
                    <Text style={styles.logoText}>Biz</Text>
                </View>
                <View style={styles.menu}>
                    <View>
                        {paymentRequired ? (
                            // Only show Content tab when payment is required
                            renderMenuItem("/content", yellowLandscapeIcon, "Content")
                        ) : (
                            // Show all tabs when payment is not required
                            <>
                                {renderMenuItem("/home", yellowNetworkIcon, "Brand Hub")}
                                {renderMenuItem("/browse", yellowGridIcon, "Browse")}
                                {renderMenuItem("/creators/search", yellowMagnifyingIcon, "Find Creators")}
                                {renderMenuItem("/content", yellowLandscapeIcon, "Content")}
                                {renderMenuItem("/outreach", yellowAnnouncementIcon, "Campaigns")}
                                {/* {renderMenuItem("/drolls", yellowChartIcon, "D-Roll")} */}
                                {renderMenuItem("/messages", yellowMessagesIcon, "Messages")}
                                {/* {renderMenuItem("/reviews", yellowAnnouncementIcon, "Reviews")} */}
                            </>
                        )}
                    </View>
                    <View>
                        {!paymentRequired && renderMenuItem("/account", gearIcon, "Account")}
                        <TouchableOpacity onPress={signOut} style={styles.menuItem}>
                        <Image source={doorIcon} style={styles.icon} />
                            <Text style={styles.menuText}>Logout</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
            <ScrollView style={styles.content}>
                <Outlet />
            </ScrollView>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        height: "100vh",
    },
    sidebar: {
        width: 250,
        backgroundColor: '#396de0',
        padding: 20,
    },
    logoContainer: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: 'center',
        marginBottom: 30,
    },
    logo: {
        width: 120,
        height: 50,
        resizeMode: 'contain',
    },
    logoText: {
        fontSize: 50,
        fontFamily: "'forma-djr-display', sans-serif",
        color: 'white',
    },
    menu: {
        flex: 1,
        justifyContent: 'space-between',
    },
    menuItem: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 10,
        paddingHorizontal: 15,
        marginBottom: 5,
    },
    selectedMenuItem: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    icon: {
        width: 20,
        height: 20,
        marginRight: 10,
    },
    menuText: {
        color: 'white',
        fontSize: 16,
        fontFamily: "'lato', sans-serif",
    },
    link: {
        textDecorationLine: 'none',
    },
    content: {
        flex: 1,
    },
});

export default SideBar;
